/**
 * Format a minor-unit currency value (pence, cents, etc) as a
 * human-readable string. Uses Intl.NumberFormat so locale + symbol
 * placement match what users expect per currency.
 *
 * Mirrors the Edge Function pricing: we always store amounts in the
 * minor unit, we always know the currency from the court row, and we
 * never do floating-point math on money.
 */
export function formatMoneyMinor(amountMinor: number, currency: string): string {
  const locale = LOCALE_BY_CURRENCY[currency.toUpperCase()] ?? "en-GB";
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency.toUpperCase(),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amountMinor / 100);
}

const LOCALE_BY_CURRENCY: Record<string, string> = {
  GBP: "en-GB",
  USD: "en-US",
  CAD: "en-CA",
  AUD: "en-AU",
  NZD: "en-NZ",
};

// 20% platform fee. Mirrors supabase/functions/_shared/stripe.ts -
// keeping it here as a client-side constant so we can show the
// "player pays £6 (venue £5 + £1 fee)" breakdown in the UI without
// waiting for an Edge Function round-trip.
export const PLATFORM_FEE_BPS = 2000;

export function computePlatformFee(unitPriceMinor: number): number {
  return Math.round((unitPriceMinor * PLATFORM_FEE_BPS) / 10_000);
}
